import { Stack } from 'expo-router';

const CoreLayout = () => {
  return (
    <Stack>
      <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
      <Stack.Screen
        name="place-details"
        options={{
          headerTitle: 'Place Details',
          headerShown: true,
        }}
        getId={({ params }) => String(params?.id) + '_' + Math.random().toString(36).substring(7)}
      />
      <Stack.Screen
        name="busker-details"
        options={{
          headerTitle: 'Busker Details',
          headerShown: true,
        }}
        getId={({ params }) => String(params?.id) + '_' + Math.random().toString(36).substring(7)}
      />
      <Stack.Screen
        name="busker-create"
        options={{
          headerTitle: 'Busker',
          headerShown: true,
        }}
        getId={({ params }) => String(params?.id) + '_' + Math.random().toString(36).substring(7)}
      />
      <Stack.Screen
        name="post-details"
        options={{
          headerTitle: 'Post Details',
          headerShown: true,
        }}
        getId={({ params }) => String(params?.id) + '_' + Math.random().toString(36).substring(7)}
      />

      <Stack.Screen
        name="comments"
        options={{
          presentation: 'modal',
          headerTitle: 'Comments',
          headerShown: true,
        }}
      />
    </Stack>
  );
};

export default CoreLayout;
